import client$47$service$47$seen$45$workbooks$46$js from '../client/service/seen-workbooks.js'
import client$47$service$47$sheetsy$46$js from '../client/service/sheetsy.js'

export default [
	client$47$service$47$seen$45$workbooks$46$js,
	client$47$service$47$sheetsy$46$js
]
